import MemberTag from '@/components/Product/MemberTag';
import { useStore } from '@/providers/app-store-provider';
import { ColorItem } from '../types';
import { hasColorItemMemberPrice } from '../utils';

export default function LensTypeMemberTag({
  colorItem,
  hasIndexPrice = false,
}: {
  colorItem: ColorItem;
  hasIndexPrice: boolean;
}) {
  const userInfo = useStore((state) => state.userInfo);
  if (
    userInfo?.is_member !== 1 ||
    (userInfo?.is_member === 1 && !hasColorItemMemberPrice(colorItem, userInfo, hasIndexPrice))
  ) {
    return <></>;
  }
  return <MemberTag level={userInfo.member_level} />;
}
